import { Dropdown, Nav, NavDropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { List } from "react-bootstrap-icons";
import { navItemsForArea } from "./navRegistry";

/* SMPW navigation. The dashboard/scheduling/reports/admin pages come from the shared navRegistry
 * (single source of truth — nav + search). SMPWDropdown adds the SMPW-only chrome: a link back to
 * the congregation, help/docs, and the donate link. */

export function NavSMPW(props: { className?: string }) {
  const { t } = useTranslation();
  return (
    <Nav className={props.className ?? "flex-column hg-nav"}>
      {navItemsForArea("smpw").map((l) => (
        <NavDropdown.Item key={l.id} as={Link} to={l.path!}>
          {t(l.labelKey)}
        </NavDropdown.Item>
      ))}
    </Nav>
  );
}

export function SMPWDropdown(props: { includeCongLinks: boolean; className?: string }) {
  const { t } = useTranslation();
  return (
    <Dropdown className={props.className}>
      <Dropdown.Toggle variant="secondary" id="dropdown-basic" aria-label={t("userinfo.button.actions")}>
        <List />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {props.includeCongLinks && (
          <>
            <Dropdown.Item as={Link} to="/" className="ps-4">
              {t("list.congregation.title")}
            </Dropdown.Item>
            <Dropdown.Divider />
          </>
        )}
        <Dropdown.Header>{t("smpw.smpw")}</Dropdown.Header>
        {navItemsForArea("smpw").map((l) => (
          <Dropdown.Item key={l.id} as={Link} to={l.path!} className="ps-4">
            {t(l.labelKey)}
          </Dropdown.Item>
        ))}
        <Dropdown.Divider />
        <Dropdown.Item as={Link} to="/smpw/docs" className="ps-4">
          {t("nav.help")}
        </Dropdown.Item>
        <Dropdown.Item
          as={Link}
          to="https://www.paypal.com/donate/?hosted_button_id=LEWREP6SGSV98"
          className="ps-4"
          target="_blank"
        >
          {t("www.donate-button")}
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}
